// [ai-generated-code]
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@services/api.service';
import { map } from 'rxjs/operators';
import { LoggerService } from '@services/logger.service';
import { VehicleRegistryModel } from '@/models/vehicle-registry/vehicle-registry.model';
import { TableDataApiParams } from '@services/practices.service';
import { TablePaginationRespModel } from '@/models/table-pagination-resp.model';

@Injectable({
  providedIn: 'root',
})
export class VehicleRegistryService extends ApiService {
  getDataForTable(
    params?: TableDataApiParams,
  ): Observable<TablePaginationRespModel<VehicleRegistryModel>> {
    return this.http
      .get<TablePaginationRespModel<VehicleRegistryModel>>(this.baseUrl + `/vehicleregistry/page`, {
        params: { ...params },
      })
      .pipe(
        map((response: any) => {
          LoggerService.log(response, 'getDataForTable VehicleRegistry');
          return response;
        }),
      );
  }

  deleteVehicleRegistry(id: number) {
    return this.http.delete(this.baseUrl + `/vehicleregistry/${id}`).pipe(
      map((response: any) => {
        LoggerService.log(response, 'deleteVehicleRegistry');
        return response;
      }),
    );
  }

  saveVehicleRegistry(vehicleRegistry: VehicleRegistryModel) {
    return this.http.post(this.baseUrl + `/vehicleregistry/save`, vehicleRegistry).pipe(
      map((response: any) => {
        LoggerService.log(response, 'saveVehicleRegistry');
        return response;
      }),
    );
  }

  getVehicleRegistryById(id: number): Observable<VehicleRegistryModel> {
    return this.http.get(this.baseUrl + `/vehicleregistry/${id}`).pipe(
      map((response: any) => {
        LoggerService.log(response, 'getVehicleRegistryById');
        return response;
      }),
    );
  }
}
